import React from "react";
import { Link } from "react-router-dom";

/* Tanı-Tedavi İç Bağları: makale metninde tedavi/tanı adları geçince ilk geçişte
   otomatik iç link üretir (SEO iç bağlantı ağı). Metin düz (HTML yok) — güvenli. */

const TREATMENT_TERMS = [
  { to: "/tedavi/bnct", terms: ["bor nötron yakalama", "BNCT"] },
  { to: "/tedavi/heavyion", terms: ["ağır iyon", "karbon iyon", "ağir iyon"] },
  { to: "/tedavi/proton", terms: ["proton tedavisi", "proton ışın", "proton"] },
  { to: "/tedavi/ipsc", terms: ["iCART", "iPSC kaynaklı CAR-T"] },
  { to: "/tedavi/cart", terms: ["CAR-T", "CAR T hücre"] },
  { to: "/tedavi/aftv", terms: ["AFTV", "kişiye özel kanser aşısı", "kanser aşısı"] },
  { to: "/tedavi/photoimmuno", terms: ["foto-immünoterapi", "fotoimmünoterapi", "ışıkla kanser tedavisi"] },
  { to: "/tedavi/immuno", terms: ["immünoterapi", "immunoterapi"] },
  { to: "/tedavi/regen", terms: ["rejeneratif", "iPSC"] },
  { to: "/tedavi/igtc", terms: ["kateterle tedavi", "hipertermi", "IGT"] },
  { to: "/tedavi/surgery", terms: ["cerrahi"] },
  { to: "/tedavi/ainpros", terms: ["eksozom", "exosome"] },
];

const TUMOR_TERMS = [
  { to: "/kanser/brain", terms: ["beyin tümörü", "beyin tümörleri", "glioblastom", "GBM"] },
  { to: "/kanser/headneck", terms: ["baş-boyun kanseri", "baş boyun kanseri", "baş ve boyun kanseri"] },
  { to: "/kanser/pancreas", terms: ["pankreas kanseri"] },
  { to: "/kanser/prostate", terms: ["prostat kanseri"] },
  { to: "/kanser/lung", terms: ["akciğer kanseri"] },
  { to: "/kanser/liver", terms: ["karaciğer kanseri", "karaciğer tümör"] },
  { to: "/kanser/breast", terms: ["meme kanseri"] },
  { to: "/kanser/colorectal", terms: ["kolon kanseri", "kolorektal kanser", "rektum kanseri"] },
  { to: "/kanser/leukemia", terms: ["lösemi"] },
  { to: "/kanser/lymphoma", terms: ["lenfoma"] },
  { to: "/kanser/esophagus", terms: ["yemek borusu kanseri", "özefagus kanseri"] },
  { to: "/kanser/bone", terms: ["kemik tümörü", "sarkom"] },
  { to: "/kanser/pediatric", terms: ["çocukluk çağı kanser", "çocukluk çağı tümör"] },
  { to: "/kanser/skin", terms: ["melanom", "cilt kanseri"] },
  { to: "/kanser/stomach", terms: ["mide kanseri"] },
  { to: "/kanser/gyn", terms: ["yumurtalık kanseri", "rahim ağzı kanseri", "jinekolojik kanser"] },
  { to: "/kanser/recurrence", terms: ["metastatik", "nüks"] },
];

const ALL = [...TREATMENT_TERMS, ...TUMOR_TERMS]
  .flatMap((g) => g.terms.map((term) => ({ term, to: g.to, canon: g.to })))
  .sort((a, b) => b.term.length - a.term.length);

const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const MASTER_RE = new RegExp(`(${ALL.map((a) => escapeRe(a.term)).join("|")})`, "giu");
const CANON_OF = Object.fromEntries(ALL.map((a) => [a.term.toLowerCase(), a.to]));

/** Metni tarar; her terim grubunun İLK geçişini <Link>'e çevirir. En fazla 8 link. */
export function linkifyText(text, linkClass, used = new Set()) {
  const cls = linkClass || "text-brand underline decoration-brand/30 underline-offset-2 hover:decoration-brand transition-colors";
  const parts = [];
  let last = 0;
  let key = 0;
  const str = String(text || "");
  for (const m of str.matchAll(MASTER_RE)) {
    if (used.size >= 8) break;
    const canon = CANON_OF[m[0].toLowerCase()];
    if (!canon || used.has(canon)) continue;
    used.add(canon);
    if (m.index > last) parts.push(str.slice(last, m.index));
    parts.push(
      <Link key={key++} to={canon} className={cls}>
        {m[0]}
      </Link>
    );
    last = m.index + m[0].length;
  }
  if (last < str.length) parts.push(str.slice(last));
  return parts;
}

/** Çok paragraflı makale gövdesini linkli <p>'ler halinde döndürür (terim başına makalede tek link). */
export function LinkedBody({ text, className, linkClass }) {
  const used = new Set();
  return (
    <>
      {String(text || "").split(/\n+/).filter(Boolean).map((para, i) => (
        <p key={i} className={className}>
          {linkifyText(para, linkClass, used)}
        </p>
      ))}
    </>
  );
}
